<template>
  <div>
    <Breadcrumbs title="Bienvenido" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div
        class="row"
        v-if="persona.id_rol == 5 || persona.id_rol == 2 || persona.id_rol == 1"
      >
        <div class="col-md-5">
          <div class="card">
            <div class="card-header">
              <div class="row">
                <div class="col-12 col-md-3">
                  <i class="fa fa-user persona" style="font-size:80px;"></i>
                </div>
                <div class="col-12 col-md-9">
                  <span class="iPersona"
                    >{{ persona.per_nombres }} {{ persona.tipo_persona }}
                    {{ persona.per_primer_apellido }}
                    {{ persona.per_segundo_apellido }}</span
                  ><br />
                  <p>
                    <strong>Nro. Documento:</strong>
                    {{ persona.per_numero_documento }}<br />
                    <strong>Fecha de registro:</strong>
                    {{ getDate(persona.fecha_reg) }}
                  </p>
                </div>
              </div>
            </div>
            <div class="card-body">
              <p></p>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card">
            <div class="card-header">
              <span class="iPersona">Calculadora de Días</span><br />
              <div class="row">
                <div class="col-md-12 text-center mt-2">
                  <!-- <button type="button" class="btn btn-outline-success" v-on:click="clickedDownload()"> -->
                  <button
                    type="button"
                    class="btn btn-outline-success"
                    @click="downloadApp"
                  >
                    <i class="fa fa-android"></i> Descargar para Celular
                  </button>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 text-center mt-2">
                  <!-- <button type="button" class="btn btn-outline-primary" v-on:click="clickedDownloadRar()"> -->
                  <button
                    type="button"
                    class="btn btn-outline-primary"
                    @click="downloadZip"
                  >
                    <i class="fa fa-windows"></i> &nbsp;Descargar &nbsp;para
                    &nbsp;&nbsp; PC
                  </button>
                </div>
              </div>
            </div>
            <div class="card-body">
              <p></p>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <TabReporteGeneral />
        </div>
      </div>
      <div class="row" v-if="persona.id_rol == 4 || persona.id_rol == 3">
        <div class="col-md-6">
          <div class="card">
            <div class="card-header">
              <div class="row">
                <div class="col-12 col-md-3">
                  <i class="fa fa-user persona" style="font-size:80px;"></i>
                </div>
                <div class="col-12 col-md-9">
                  <span class="iPersona"
                    >{{ persona.per_nombres }} {{ persona.tipo_persona }}
                    {{ persona.per_primer_apellido }}
                    {{ persona.per_segundo_apellido }}</span
                  ><br />
                  <p>
                    <strong>Nro. Documento:</strong>
                    {{ persona.per_numero_documento }}<br />
                    <strong>Fecha de registro:</strong>
                    {{ getDate(persona.fecha_reg) }}
                  </p>
                </div>
              </div>
            </div>
            <div class="card-body">
              <p></p>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <TabReporteGeneral />
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12 col-md-12">
          <div class="card">
            <div class="card-body text-center">
              <!--<h1>SICOBOT</h1>-->
              <h3>SEGUIMIENTO Y EVALUACIÓN DEL SISTEMA AUTOMATIZADO</h3>
              <h4>“ESTADO DIGITAL - CONTROL MIGRATORIO ED-2”</h4>
              <div class="img-responsive">
                <img
                  src="../assets/images/logo/logo_digemig.png"
                  alt="digemig"
                  width="50%"
                  height="50%"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="col-4 col-md-4">
                <div class="card">
                  <div class="card-header">
                    MANUAL DE USUARIO
                  </div>
                  <div class="card-body text-center">
                    <p>DECRETO SUPREMO No 4574 del 26 de Agosto de 2021</p>
                    <a href="" class="btn btn-primary"><i class="fa fa-download"></i> Descargar</a>
                  </div>
                </div>
                
              </div> -->
      </div>
    </div>
    <!-- Container-fluid Ends-->
    <Loading v-if="cargando" />
  </div>
</template>

<script>
import Loading from "../components/Loading.vue";
import TabReporteGeneral from "@/components/TabReporteGeneral.vue";
import moment from "moment";
import FileSaver from "file-saver";

export default {
  data() {
    return {
      persona: {
        id_persona: 0,
        per_nombres: "",
        per_primer_apellido: "",
        per_segundo_apellido: "",
        per_fecha_nacimiento: "",
        nacionalidad: "",
      },
      cargando: false,
    };
  },
  components: {
    Loading,
    TabReporteGeneral,
  },
  methods: {
    getDate: function(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    async getPersona() {
      this.cargando = true;
      try {
        let res = await this.axios.get(`/usuarioGetDataUser`);
        if (res.status == 200) {
          this.cargando = false;
          this.persona = res.data.contenido;
        }
      } catch (error) {
        this.cargando = false;
        this.$swal({
          title: "Información",
          text: "Ocurrio un Error al realizar la consulta!",
          type: "error",
          confirmButtonText: "Aceptar",
        });
      }
    },
    async downloadZip() {
      try {
        let resultados = await this.axios.get("/descarga_zip", {
          responseType: "blob",
        });
        if (resultados.status == 200) {
          let file = new Blob([resultados.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          FileSaver.saveAs(file, "calculadora.zip");
        }
      } catch (error) {
        console.log("catch: ", error);
      }
    },
    async downloadApp() {
      try {
        let resultados = await this.axios.get("/descarga_app", {
          responseType: "blob",
        });
        if (resultados.status == 200) {
          let file = new Blob([resultados.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          FileSaver.saveAs(file, "calculadora.apk");
        }
      } catch (error) {
        console.log("catch: ", error);
      }
    },
  },
  created() {
    this.getPersona();
    //console.log();
  },
};
</script>
<style>
.persona {
  color: rgb(115, 102, 255);
}
.iPersona {
  color: #000;
  font-size: 20px !important;
  font-weight: bold;
}
</style>
